import React from "react";
import ReactApexChart from "react-apexcharts";
import {  Grid, Button, Popup } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// let colors = ["#f0f9ba", "#fff1ae", "#fed38c", "#feb669", "#f3854e"];
let colors = ["#1542E6", "#E63A15", "#59E615", "#fed38c"];

//console.log('CAD PO', data);

export default class CChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  setMinMax = (min, max) => {
    this.props.setSelectionMinMax(min, max);
  };

  selectionEvent(e, chartContext) {

    let { xaxis, yaxis } = chartContext;
    this.setMinMax(xaxis.min, xaxis.max);

  }


  render() {

    let mainOptions = {
        forecastDataPoints: {
            count: 5,
            // count: this.props.forecastdays,
        },
        colors: ['#546E7A'],
        stroke: {
            width: 3
        },
        dataLabels: {
            enabled: false
        },
        fill: {
            opacity: 1,
        },
        markers: {
            size: 0
        },
        xaxis: {
            type: 'datetime',
            labels: {
                format: 'dd MMM yy',
            },             
        },
    };

    let brushOptions = {
        colors: ['#008FFB'],
        fill: {
          opacity: 1,
            // type: 'gradient',
            // gradient: {
            //     opacityFrom: 0.91,
            //     opacityTo: 0.1,
            // }
        },
        xaxis: {
            type: 'datetime',
            labels: {
                format: 'dd MMM yy',    
            }, 
            tooltip: {
                enabled: false
            }
        },
        yaxis: {
            tickAmount: 2,             
        }
    
    };

    let seriesRF = [{
      name: 'Rainfall (mm)',
      data: this.props.rf_data
    }];

    

    let optionsLineRF = {
        ...brushOptions,
        chart: {
          id: 'rfChartBrush',
          type: 'area',
          // group: 'sync1',
          brush:{
            target: 'rfChart',
            enabled: true
          },
          selection: {
            enabled: true,
            xaxis: {
                max: this.props.selection_max,
                min: this.props.selection_min,
            }
          },
          events: {
            selection: this.selectionEvent.bind(this)
          }
        },
    };

    let seriesIrr = [{
      name: 'Irrigation Requirement (TMC)',
      data: this.props.ir_data
    }];

    let optionsIrr = {
        ...mainOptions,
        chart: {
            id: 'irrChart',
            group: 'sync',
            type: 'line',
            toolbar: {
                autoSelected: 'pan',
                show: false
            }
        },
        yaxis: {
            tickAmount: 5,
            title: {
                text: 'Irrigation Requirement (TMC)',
                style: {
                    fontSize: '10px',
                },
            },
        },             
    };

    let optionsLineIrr = {
        ...brushOptions,
      chart: {
        id: 'irrChartBrush',
        // group: 'sync1',
        type: 'area',
        brush:{
          target: 'irrChart',
          enabled: true
        },
        selection: {
          enabled: true,
          xaxis: {
            max: this.props.selection_max,
            min: this.props.selection_min,

          }
        },
        events: {
            selection: this.selectionEvent.bind(this)
          }
      }  
    };

    let optionsRF = {
      ...mainOptions,
      chart: {
          id: 'rfChart',
          group: 'sync',
          type: 'bar',
          toolbar: {
              autoSelected: 'pan',
              show: false
          }
      },
      yaxis: {
          tickAmount: 5,
          title: {
              text: 'Rainfall (mm)'
          },
      }
  };

    return (
        <>

        <Grid.Column
                    style={{
                      width: "25%",
                      height: "100%",
                      padding: "0px",
                      border: "1px",
                    }}
                  >
                    <div id="rainfall-div" key={"rainfall-div"} style={{border: '1px black', borderStyle: 'solid', height: "100%", width: "100%"}}>
                    <Popup
                        trigger={
                          <Button
                            size="tiny"
                            compact
                            style={{ 
                              padding: "8px",
                              right:'4px',
                              top:'4px',
                              position:'absolute',
                            }}
                          >
                                  <FontAwesomeIcon icon="info-circle" size="lg" />
                          </Button>
                        }
                        position="right center"
                      >
                    
                      <Popup.Content>
                        Data Source: <br /> Near Real Time Data –IMD,<br /> Forecast Data – GEFS

                      </Popup.Content>
                      
                     </Popup>

                    <b>Daily Rainfall for <br /> {this.props.commandAreaName} </b>

                        <div key={"rainfall-div-wrapper"} id="wrapper" style={{height: '100%'}}>
                            <div key={"rainfall-div-wrapper-chart"} id="chart-bar-rf" style={{height: '60%'}}>
                            <ReactApexChart 
                                key={"rainfall-div-wrapper-bar-chart"}
                                // type="bar"
                                options={optionsRF} 
                                series={seriesRF} 
                                height={'100%'} 
                            />
                            </div>
                            <div key={"rainfall-div-wrapper-chart-brush"} id="chart-bar-brush-rf" style={{height: '40%'}}>
                            <ReactApexChart 
                                key={"rainfall-div-wrapper-brush-chart"}
                                // type="area"
                                options={optionsLineRF}
                                series={seriesRF} 
                                height={'70%'} 
                            />
                            </div>
                        </div>
                    </div>

                  </Grid.Column>
                  
                  <Grid.Column
                    style={{
                      width: "25%",
                      height: "100%",
                      padding: "0px",
                      border: "1px",
                    }}
                  >
                    <div key={"irrigation-div"} id="irrigation-div" style={{border: '1px black', borderStyle: 'solid', height: "100%", width: "100%"}}>
                    <b>Daily Irrigation Requirement for <br /> {this.props.commandAreaName} </b> 


                    <div key={"irrigation-div-wrapper"} id="wrapper-irr" style={{height: '100%'}}>
                            <div id="chart-line-ir" style={{height: '60%'}}>
                            <ReactApexChart 
                                key={"irrigation-div-wrapper-chart"}
                                // type="line"
                                options={optionsIrr} 
                                series={seriesIrr} 
                                height={'100%'} 
                            />
                            </div>
                            <div id="chart-line-brush-ir" style={{height: '40%'}}>
                            <ReactApexChart 
                                key={"irrigation-div-wrapper-chart-brush"}
                                // type="area"
                                options={optionsLineIrr}
                                series={seriesIrr} 
                                height={'70%'} 
                            />
                            </div>
                        </div>
                        
                    </div>

                  </Grid.Column>
                  </>

    );
  }
  
}


